(function(angular) {
	'use strict';
	var core = angular.module('Core');

	/*
	 * Local storage service
	 */
	core.service('LocalCache', ['$log', function($log) {
			var instance = this;

			instance.cache = {};

			/**
			 * Get the value attached to a key or null if not set
			 * @param {String} key the value to get
			 * @returns {Object} the value behind the key
			 */
			this.getValue = function(key) {
				var val = null;
				if (instance.cache[key]) {
					val = instance.cache[key];
				}
				return val;
			};

			/**
			 * True if the value is set
			 * @param {type} key the key to check
			 * @returns {Boolean} true when a value is set for the key
			 */
			this.isInCache = function(key) {
				var v = this.getValue(key);
				return v !== null && v !== '';
			};

			/**
			 * Set the value for a key
			 * @param {String} key the key to use
			 * @param {Object} value the value to save in the local storage
			 */
			this.setValue = function(key, value) {
				$log.info('LocalCache: Cache set for key ' + key);
				instance.cache[key] = value;
			};



			/**
			 * Clear the value attached to the key
			 * @param {String} key the key to remove from the local storage
			 */
			this.clearValue = function(key) {
				this.setValue(key, null);
			};
		}]);
})(angular);